import { stackedNotificationService } from '@pn/services/notifications/stackedNotificationService';

/**
 * Default notification service.
 */
export const notificationService = stackedNotificationService;
